import {Component, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import {jqxGridComponent} from '../../../../assets/jqwidgets-ts/angular_jqxgrid';
import {_GridService} from '../../../ng1-services/grid.service';

import {Grid} from '../../../interfaces/grid.interface';
import {_RuleLiquidityProviderService} from "../../../services/ruleLiquidityProvider.service";

declare var $:any, dump: any;

@Component({
  selector: 'broker-selection',
  templateUrl: './broker-selection.component.html',
  styleUrls: ['./broker-selection.component.css'],
})

export class BrokerSelectionBranch implements OnInit {

  @ViewChild('counterpartyCreditLimitGrid') counterpartyCreditLimitGrid: jqxGridComponent;
  @ViewChild('counterpartyExposureLimitGrid') counterpartyExposureLimitGrid: jqxGridComponent;
  @ViewChild('accountNettingGrid') accountNettingGrid: jqxGridComponent;

  //grid settings
  private counterpartyCreditLimitSettings: Grid;
  private counterpartyExposureLimitSettings: Grid;
  private accountNettingSettings: Grid;

  constructor (private route: ActivatedRoute, private titleService: Title, private ruleLiquidityProviderService: _RuleLiquidityProviderService, private gridService: _GridService) { }

  ngOnInit() {
    this.titleService.setTitle("WiseRisk | Broker Selection");

    this.loadCreditLimits();
    this.loadExposureLimits();
    this.loadAccountRestrictions();
  }

  loadCreditLimits (){
    this.counterpartyCreditLimitSettings = null;
    this.ruleLiquidityProviderService.getLiquidityProviders('CREDIT_LIMIT').then((data) => {
      var msgContainer = "counterpartyCreditLimitMsg";
      var source = {
        id : 'ruleLiquidityProviderId',
        localdata: data,
        datafields : [
          {
            name : 'ruleLiquidityProviderId',
            type : 'int'
          }, {
            name : 'organizationId',
            type : 'int'
          }, {
            name : 'ruleType',
            type : 'string'
          }, {
            name : 'entityIdDisplay',
            value: "accountId",
            values: {
              source: this.gridService.GetAccountDataAdapter(true).records,
              value: 'entityId',
              name: 'display',
            }
          }, {
            name : 'accountId',
            type : 'string'
          }, {
            name : 'liquidityProviderIdDisplay',
            value : 'liquidityProviderId',
            values: {
              source: this.gridService.GetLiquidityProviderDataAdapter().records,
              value: 'liquidityProviderId',
              name: 'code',
            }
          },{
            name : 'liquidityProviderId',
            type : 'int'
          },{
            name : 'quantityLimit',
            type : 'string'
          }
        ],
        updaterow : (rowid, rowdata, commit) => {
          rowdata.ruleType = "CREDIT_LIMIT";
          if(rowdata.entityId != 0){
            rowdata.entityType = "ACCOUNT";
          }else{
            rowdata.entityType = "all";
          }
          //New Row
          if(rowdata.rowId < 1){
            this.ruleLiquidityProviderService.createLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Credit Limit Added');
              this.loadCreditLimits();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }else{
            this.ruleLiquidityProviderService.updateLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Credit Limit Updated');
              this.loadCreditLimits();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleLiquidityProviderService.deleteLiquidityProvider(rowdata.ruleLiquidityProviderId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Credit Limit Deleted');
            this.loadCreditLimits();
          },(data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh:() => {
          this.loadCreditLimits();
        },
        getGrid: () => { return this.counterpartyCreditLimitGrid; }
      };
      this.counterpartyCreditLimitSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text : 'Account',
          columntype : 'dropdownlist',
          datafield : 'accountId',
          displayfield : "entityIdDisplay",
          width : '30%',
          createeditor :  (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridService.GetAccountDataAdapter(true),
              displayMember : "display",
              valueMember : "entityId"
            });
          }
        }, {
          text : 'Counter Party',
          columntype : 'dropdownlist',
          datafield : 'liquidityProviderId',
          displayfield : 'liquidityProviderIdDisplay',
          width : '30%',
          createeditor :  (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridService.GetLiquidityProviderDataAdapter(),
              displayMember : "code",
              valueMember : "liquidityProviderId"
            });
          }
        }, {
          text : 'Credit Limit',
          columntype : 'textbox',
          datafield : 'quantityLimit',
          width : '30%',
        }],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadExposureLimits (){
    this.counterpartyExposureLimitSettings = null;
    this.ruleLiquidityProviderService.getLiquidityProviders('EXPOSURE_LIMIT').then((data) => {
      var msgContainer = "counterpartyExposureLimitMsg";
      var source = {
        id : 'ruleLiquidityProviderId',
        localdata: data,
        datafields : [
          {
            name : 'ruleLiquidityProviderId',
            type : 'int'
          }, {
            name : 'organizationId',
            type : 'int'
          }, {
            name : 'ruleType',
            type : 'string'
          }, {
            name : 'liquidityProviderIdDisplay',
            value : 'liquidityProviderId',
            values: {
              source: this.gridService.GetLiquidityProviderDataAdapter().records,
              value: 'liquidityProviderId',
              name: 'code',
            }
          },{
            name : 'liquidityProviderId',
            type : 'int'
          },{
            name : 'quantityLimit',
            type : 'string'
          }
        ],
        updaterow : (rowid, rowdata, commit) => {
          rowdata.ruleType = "EXPOSURE_LIMIT";
          rowdata.entityType = "all";
          //New Row
          if(rowdata.rowId < 1){
            this.ruleLiquidityProviderService.createLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Exposure Limit Added');
              this.loadExposureLimits();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }else{
            this.ruleLiquidityProviderService.updateLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Exposure Limit Updated');
              this.loadExposureLimits();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleLiquidityProviderService.deleteLiquidityProvider(rowdata.ruleLiquidityProviderId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Exposure Limit Deleted');
            this.loadExposureLimits();
          },(data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh:() => {
          this.loadExposureLimits();
        },
        getGrid: () => { return this.counterpartyExposureLimitGrid; }
      };
      this.counterpartyExposureLimitSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text : 'Counter Party',
          columntype : 'dropdownlist',
          datafield : 'liquidityProviderId',
          displayfield : 'liquidityProviderIdDisplay',
          width : '30%',
          createeditor :  (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridService.GetLiquidityProviderDataAdapter(),
              displayMember : "code",
              valueMember : "liquidityProviderId"
            });
          }
        }, {
          text : 'Exposure Limit',
          columntype : 'textbox',
          datafield : 'quantityLimit',
          width : '30%',
        }],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }

  loadAccountRestrictions (){
    this.accountNettingSettings = null;
    this.ruleLiquidityProviderService.getLiquidityProviders('NETTING_RESTRICTION').then((data) => {
      var msgContainer = "accountNettingMsg";
      var source = {
        id : 'ruleLiquidityProviderId',
        localdata: data,
        datafields : [
          {
            name : 'ruleLiquidityProviderId',
            type : 'int'
          }, {
            name : 'organizationId',
            type : 'int'
          }, {
            name : 'ruleType',
            type : 'string'
          }, {
            name : 'entityIdDisplay',
            value: 'accountId',
            values: {
              source: this.gridService.GetAccountDataAdapter(false).records,
              value: 'entityId',
              name: 'display',
            }
          }, {
            name : 'accountId',
            type : 'int'
          }
        ],
        updaterow : (rowid, rowdata, commit) => {
          rowdata.ruleType = "NETTING_RESTRICTION";
          rowdata.entityType = "ACCOUNT";
          //New Row
          if(rowdata.rowId < 1){
            this.ruleLiquidityProviderService.createLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Netting Restriction Added');
              this.loadAccountRestrictions();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }else{
            this.ruleLiquidityProviderService.updateLiquidityProvider(rowdata).toPromise().then((data) => {
              this.gridService.SuccessMsg(msgContainer, 'Netting Restriction Updated');
              this.loadAccountRestrictions();
            },(data) => {
              this.gridService.ErrorMsg(msgContainer, data);
            });
          }
        },
        deleterow: (rowdata) => {
          this.ruleLiquidityProviderService.deleteLiquidityProvider(rowdata.ruleLiquidityProviderId).toPromise().then((data) => {
            this.gridService.SuccessMsg(msgContainer, 'Netting Restriction Deleted');
            this.loadAccountRestrictions();
          },(data) => {
            this.gridService.ErrorMsg(msgContainer, data);
          });
        },
        refresh:() => {
          this.loadAccountRestrictions();
        },
        getGrid: () => { return this.accountNettingGrid; }
      };
      this.accountNettingSettings = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [{
          text : 'Account',
          columntype : 'dropdownlist',
          datafield : 'accountId',
          displayfield : "entityIdDisplay",
          width : '30%',
          createeditor :  (row, cellvalue, editor) => {
            editor.jqxDropDownList({
              source : this.gridService.GetAccountDataAdapter(false),
              displayMember : "display",
              valueMember : "entityId"
            });
          }
        }],
        renderstatusbar: (statusbar: any) => {
          this.gridService.RenderStatusBar(statusbar, source);
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/rules/broker-selection/broker-selection.component.ts